export default function normalizeCif(cif: string): string {
  if (cif) {
    return cif.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  }
  return '';
}
